import { render } from "./NavbarUserDropdown.vue?vue&type=template&id=2c4455ae&scoped=true"
import script from "./NavbarUserDropdown.vue?vue&type=script&lang=js"
export * from "./NavbarUserDropdown.vue?vue&type=script&lang=js"

import "./NavbarUserDropdown.vue?vue&type=style&index=0&id=2c4455ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4455ae"]])

export default __exports__